/**
 * Columns Panel Component
 *
 * Panel for managing column visibility and order.
 * Based on original MyVault ColumnsPanel.tsx patterns.
 */

import React, { createContext } from "react";
import { Box, Typography, Checkbox, List, ListItem } from "@mui/joy";

export type ColumnReorderHandler = (newOrder: string[]) => void;

// Context for column reorder handler
export const ColumnReorderContext = createContext<ColumnReorderHandler | null>(
  null,
);

interface ColumnsPanelProps {
  columns: Array<{ field: string; headerName: string }>;
  visibleColumns: string[];
  onVisibilityChange: (field: string, visible: boolean) => void;
}

export default function ColumnsPanel({
  columns,
  visibleColumns,
  onVisibilityChange,
}: ColumnsPanelProps) {
  return (
    <Box sx={{ p: 2, minWidth: 250 }}>
      <Typography level="title-sm" sx={{ mb: 2 }}>
        Column Visibility
      </Typography>
      <List size="sm">
        {columns.map((col) => (
          <ListItem key={col.field}>
            <Checkbox
              size="sm"
              checked={visibleColumns.includes(col.field)}
              onChange={(e) => onVisibilityChange(col.field, e.target.checked)}
              label={col.headerName}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
